// import { Amplify } from 'aws-amplify';

// export default function amplifyConfig(configOptions = {}) {
//   const defaultConfig = {
//     Auth: {
//       Cognito: {
//         userPoolId: process.env.REACT_APP_COGNITO_USER_POOL_ID,
//         userPoolClientId: process.env.REACT_APP_COGNITO_USER_POOL_WEB_CLIENT_ID,
//         identityPoolId: process.env.REACT_APP_COGNITO_IDENTITY_POOL_ID,
//       },
//     },
//   };

//   Amplify.configure({ ...defaultConfig, ...configOptions });
// }
import { Amplify } from 'aws-amplify';
import { getTenantFromUrl } from './tenant';

export default function amplifyConfig(configOptions = {}) {
  const isRedwoodSeed = getTenantFromUrl() === 'redwoodseed';
  //  Live
  const defaultConfig = {
    Auth: {
      Cognito: {
        userPoolId: isRedwoodSeed
          ? process.env.REACT_APP_COGNITO_USER_POOL_ID_REDWOODSEED
          : process.env.REACT_APP_COGNITO_USER_POOL_ID,
        userPoolClientId: isRedwoodSeed
          ? process.env.REACT_APP_COGNITO_USER_POOL_WEB_CLIENT_ID_REDWOODSEED
          : process.env.REACT_APP_COGNITO_USER_POOL_WEB_CLIENT_ID,
        identityPoolId: isRedwoodSeed 
          ? process.env.REACT_APP_COGNITO_IDENTITY_POOL_ID_REDWOODSEED 
          : process.env.REACT_APP_COGNITO_IDENTITY_POOL_ID,
      },
    },
  };
  // Redwood Seed
  // const defaultConfig = {
  //   Auth: {
  //     Cognito: {
  //       userPoolId: process.env.REACT_APP_COGNITO_USER_POOL_ID_REDWOODSEED,
  //       userPoolClientId: process.env.REACT_APP_COGNITO_USER_POOL_WEB_CLIENT_ID_REDWOODSEED,
  //       identityPoolId: process.env.REACT_APP_COGNITO_IDENTITY_POOL_ID_REDWOODSEED,
  //     },
  //   },
  // };
  // Initial Config
  // const defaultConfig = {
  //   Auth: {
  //     Cognito: {
  //       userPoolId: process.env.REACT_APP_COGNITO_USER_POOL_ID,
  //       userPoolClientId: process.env.REACT_APP_COGNITO_USER_POOL_WEB_CLIENT_ID,
  //       identityPoolId: process.env.REACT_APP_COGNITO_IDENTITY_POOL_ID,
  //     },
  //   },
  // };
  Amplify.configure({ ...defaultConfig, ...configOptions });
}